import { insertSignatureIntoComposeBody } from "../services/outlookComposeService";

const COMPOSE_HANDLER_NAME = "onNewMessageComposeHandler";

function registerEventHandlers(): void {
  try {
    Office.actions.associate(COMPOSE_HANDLER_NAME, onNewMessageComposeHandler);
    console.log(`[SignaFlow] Office.actions.associate registered for ${COMPOSE_HANDLER_NAME}`);
  } catch (error) {
    console.error("[SignaFlow] Failed to register compose launch handler.", error);
  }
}

/**
 * Automatic compose handler for Outlook launch events.
 *
 * Runs when compose forms are created (new/reply/reply all/forward where
 * supported by the current Outlook client/event model).
 */
async function onNewMessageComposeHandler(event: Office.AddinCommands.Event): Promise<void> {
  console.log("[SignaFlow] OnNewMessageCompose event fired.");

  try {
    const mailboxRequirement10Supported = Office.context.requirements.isSetSupported("Mailbox", "1.10");
    console.log(`[SignaFlow] Mailbox 1.10 supported: ${mailboxRequirement10Supported}`);
    console.log(`[SignaFlow] Item available: ${Boolean(Office.context.mailbox?.item)}`);
    console.log(`[SignaFlow] Mailbox user: ${Office.context.mailbox?.userProfile?.emailAddress ?? "unknown"}`);

    console.log("[SignaFlow] Automatic signature insertion started.");
    const result = await insertSignatureIntoComposeBody();
    console.log(`[SignaFlow] Automatic signature insertion finished with result: ${result}`);
  } catch (error) {
    // Never throw from launch handlers. Log diagnostics and let compose continue.
    console.error("[SignaFlow] Automatic signature insertion failed.", error);
  } finally {
    console.log("[SignaFlow] Calling event.completed().");
    event.completed();
  }
}

// Register immediately for event runtime execution paths.
registerEventHandlers();

// Register again during Office initialization for host runtimes that initialize later.
Office.initialize = () => {
  console.log("[SignaFlow] Office.initialize invoked in commands runtime.");
  registerEventHandlers();
};
